import { PropTypes } from 'prop-types'
import React from 'react'
import { Redirect, Route } from 'react-router-dom'

import { getQueryParams } from 'helpers/urls'

const PublicRoute = props => {
    const { next, source } = getQueryParams()
    let redirectUrl = '/'
    if (next) redirectUrl = `/${next}`
    /* source is needed for group study signup flow.
     * if user has landed on login page from group study landing page with ?source='openroom'
     * append source to query params
     */
    if (source) redirectUrl = `/${source}`

    const arr = ['/login', '/signup']

    return !props.authenticated || !arr.includes(props.path) ? (
        <Route exact {...props} component={props.component} />
    ) : (
        <Redirect to={redirectUrl} />
    )
}

PublicRoute.propTypes = {
    path: PropTypes.string.isRequired,
    exact: PropTypes.bool.isRequired,
    component: PropTypes.any.isRequired,
}

PublicRoute.defaultProps = {
    path: null,
    exact: false,
    component: null,
}

export default PublicRoute
